import axios from "../../plugins/axios";

export const state = {
    filtros: null,
}

export const mutations = {
    SET_FILTROS(state, filtros) {
        state.filtros = filtros;
    },
}

export const getters = {
    getFiltros(state) {
        return state.filtros;
    },
}

export const actions = {
    balancosPorAno(context, payload) {
        return axios.get('balanco-energetico/listar-balancos-ano' + payload);
    },
    todosOsBalancosPaginados(context, payload) {
        return axios.get('balanco-energetico' + payload);
    },
    balancosPorReferencia(context, payload) {
        return axios.get('balanco-energetico/' + payload.referencia + payload.query);
    },
    balancosPorReferenciaeConsorcio(context, payload) {
        return axios.get('balanco-energetico/' + payload.referencia + '/' + payload.consorcio + '?' + payload.query);
    },
    balancoPorReferenciaUC(context, payload) {
        return axios.get('balanco-energetico/' + payload.id + '/cliente');
    },
    listarHistoricoAnteriores(context, payload) {
        return axios.get('balanco-energetico/historico/' + payload.id + '/balancos');
    },
    balancosPorReferenciaLista(context, payload) {
        return axios.put('balanco-energetico/' + payload.referencia + '/lista', {
            query: payload.query,
            referencia: payload.referencia
        });
    },
    historicoBalanco(context, payload) {
        return axios.get('balanco-energetico/historico/' + payload + '/log?loading=false&loading=false');
    },
    boletarEmMassa(context, payload) {
        return axios.post('balanco-financeiro/boletar-em-massa', payload);
    },
    selecionarBalanco(context, payload) {
        return axios.post('balanco-energetico/selecionar-balanco', payload);
    },
    selecionarTodos(context, payload) {
        return axios.post('balanco-energetico/selecionar-todos-balancos', payload);
    },
    retornaQuantidadeSelecionada(context, payload) {
        return axios.get('balanco-energetico/retorna-quantidade-selecionada?loading=false&loading=false&referencia=' + payload.referencia + '&estado=' + payload.estado);
    },
    inativarEmMassa(context, payload) {
        return axios.get('balanco-energetico/inativar-em-massa' + payload);
    },
    verificarControleBalanco(context, payload) {
        return axios.get('controle-balanco/' + payload.referencia + '/balanco').then(response => response.data);
    },
    reprocessar(context, payload) {
        return axios.post('fix/reprocessar', payload);
    },
    reprocessarEstado(context, payload) {
        return axios.post('fix/reprocessar-por-estado', payload);
    },
    getEstornosCount(context, payload) {
        return axios.get('balanco-energetico/balanco-estornados');
    },
    reprocessarSelecionados(context, payload) {
        return axios.post('balanco-energetico/reprocessar', payload);
    },
    atualizarEmMassa(context, payload) {
        return axios.post('balanco-energetico/atualizacao-em-massa', payload);
    },
    excluirBalanco(context, payload) {
        let requestData = {};
        if (payload.ids) {
            requestData = { ids: payload.ids };
        } else if (payload.referencia && payload.estado) {
            requestData = { referencia: payload.referencia, estado: payload.estado };
        }
        return axios.delete('balanco-energetico/excluir-selecionados', { data: requestData }).then(response => response.data);
    },
    mudarEstado(context, payload) {
        return axios.post('balanco-energetico/mudar-estado', payload);
    },
    AcaoReprocessar(context, payload) {
        return axios.post('balanco-energetico/reprocessar-acao', payload);
    },
    calcularPorGD(context, payload) {
        return axios.post('balanco-energetico/calcular-gd/job', payload);
    },
    trocainfo(context, payload) {
        return axios.post('balanco-energetico/troca-info', payload);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/balanco.js